import { useState } from "react";

/**
 * Round instructor/creator avatar.
 *
 * Renders the profile image when it is present and loads successfully.
 * Falls back to a colored initial circle when the image is missing OR fails
 * to load — so a broken image URL never collapses to nothing.
 *
 * @param {string} name       Instructor name (used for alt text + initial).
 * @param {string} image      Profile image URL (may be empty/broken).
 * @param {string} primary    Community primary color for the fallback circle.
 * @param {string} sizeClass  Tailwind width/height classes (default w-4 h-4).
 * @param {string} textClass  Tailwind font-size class for the initial.
 * @param {string} extraClass Extra classes applied to both variants.
 */
export default function InstructorAvatar({
  name,
  image,
  primary,
  sizeClass = "w-4 h-4",
  textClass = "text-[8px]",
  extraClass = "",
}) {
  const [failed, setFailed] = useState(false);
  const hasImage = image && String(image).trim() && !failed;

  if (hasImage) {
    return (
      <img
        src={image}
        alt={name || ""}
        className={`${sizeClass} rounded-full object-cover ${extraClass}`}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span
      className={`${sizeClass} rounded-full flex items-center justify-center ${textClass} font-bold text-white ${extraClass}`}
      style={{ backgroundColor: primary }}
    >
      {(name || "?").charAt(0).toUpperCase()}
    </span>
  );
}
